import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import set from 'lodash/set'
import Vue from 'vue'
import VueLodash from 'vue-lodash'

// name is optional
Vue.use(VueLodash, {
	name: 'custom',
	lodash: { isNil, isEmpty,set }
})
export default function ({
	$axios,
	redirect,
	store
}, inject) {
	inject('lodash', { isNil, isEmpty,set })
 }
